export function uploadedIconsAreTheExpected(icons: File[], expectedIcons: string[]): boolean {

    const iconsSorted = icons.sort((a: File, b: File) => a.name.localeCompare(b.name));

    const expectedFiles = expectedIcons
                    .sort((a, b) => a.localeCompare(b));

    const areEqual = iconsSorted.every((value: File, index: number) => value.name === expectedFiles[index]);
    
    if (!areEqual) return false;
    return true;
}